import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import setMailboxCalendarConfiguration from '../services/setMailboxCalendarConfiguration';
import storeCalendarMailboxConfiguration from './storeCalendarMailboxConfiguration';

export default async function saveCalendarMailboxConfiguration(
    mailboxCalendarConfiguration: MailboxCalendarConfiguration
): Promise<OptionsResponseBase> {
    await storeCalendarMailboxConfiguration(mailboxCalendarConfiguration);
    const response: OptionsResponseBase = await setMailboxCalendarConfiguration(
        mailboxCalendarConfiguration
    );
    return response;
}
